module.exports = __webpack_public_path__ + "static/img/XugarHero_warningLow.a7b88a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/brand/xugarhero/assets/xugarHero/XugarHero_warningLow.svg
// module id = cJxL
// module chunks = 1